import React from 'react';

const PageNotFound = () => (
  <div className="GenericText__content">
    <h2>Yikes! Page Not Found!</h2>

    <p>
      You managed to find a page that does not exist. We suggest you enjoy the
      pages that do!
    </p>

    <p>Check out the menu above.</p>
  </div>
);

export default PageNotFound;
